import { Invoice, Property, PropertyStatus, Tenant, TenantType, UnitType, Transaction, MaintenanceRequest } from "./types";

export const KUWAIT_LOCATIONS = {
  "العاصمة": ["مدينة الكويت", "الشرق", "المرقاب", "جبلة", "دسمان", "الصالحية", "بنيد القار", "الدسمة", "الدعية", "المنصورية", "ضاحية عبدالله السالم", "النزهة", "الفيحاء", "الشامية", "الروضة", "العديلية", "الخالدية", "كيفان", "القادسية", "قرطبة", "السرة", "اليرموك", "الشويخ", "الري", "غرناطة", "الصليبيخات", "الدوحة", "نهضة", "مدينة جابر الأحمد", "القيروان"],
  "حولي": ["حولي", "الرميثية", "الجابرية", "السالمية", "مشرف", "بيان", "البدع", "النقرة", "ميدان حولي", "ضاحية مبارك العبدالله الجابر", "سلوى", "جنوب السرة", "الزهراء", "الصديق", "حطين", "السلام", "الشهداء"],
  "الفروانية": ["الفروانية", "الفردوس", "ضاحية صباح الناصر", "العارضية", "العارضية الحرفية", "الأندلس", "الرقعي", "خيطان", "الرحاب", "الرابية", "العمرية", "جليب الشيوخ", "إشبيلية", "الضجيج", "عبدالله المبارك", "غرب عبدالله المبارك"],
  "مبارك الكبير": ["العدان", "القصور", "القرين", "ضاحية مبارك الكبير", "ضاحية صباح السالم", "المسيلة", "أبو فطيرة", "صبحان", "الفنيطيس", "أبو الحصانية"],
  "الأحمدي": ["الفحيحيل", "الأحمدي", "الوفرة", "الزور", "الخيران", "ميناء عبدالله", "المنقف", "الصباحية", "الظهر", "العقيلة", "جابر العلي", "المهبولة", "الرقة", "هدية", "أبو حليفة", "الفنطاس", "مدينة صباح الأحمد", "مدينة الخيران السكنية"],
  "الجهراء": ["الجهراء", "الواحة", "العيون", "القصر", "النسيم", "تيماء", "النعيم", "جنوب الجهراء (مدينة سعد العبدالله)", "الجهراء الصناعية", "الصليبية", "أمغرة", "كبد", "العبدلي", "المطلاع"]
};

// --- MOCK DATA POPULATION ---

export const MOCK_PROPERTIES: Property[] = [
  {
    id: 'P001',
    name: 'برج الجوهرة',
    governorate: 'العاصمة',
    city: 'الشرق',
    block: '2',
    street: 'شارع أحمد الجابر',
    buildingNumber: '15',
    civilId: '99887711',
    type: 'استثماري',
    buildYear: '2019',
    area: 1500,
    status: 'نشط',
    bankAccount: 'NBK - KW987654321',
    bookValue: 3500000,
    estimatedValue: 4200000,
    units: [
      { id: 'U1', unitNumber: '101', type: 'شقة', rent: 550, contractRent: 550, rooms: 3, bathrooms: 2, area: 110, status: 'occupied', tenantName: 'محمد أحمد', tenantId: 'T001' },
      { id: 'U2', unitNumber: '102', type: 'شقة', rent: 550, contractRent: 550, rooms: 3, bathrooms: 2, area: 110, status: 'occupied', tenantName: 'سارة خالد', tenantId: 'T002' },
      { id: 'U3', unitNumber: '201', type: 'شقة', rent: 600, contractRent: 600, rooms: 3, bathrooms: 3, area: 125, status: 'vacant' },
      { id: 'U4', unitNumber: 'Store-1', type: 'محل تجاري', rent: 1200, contractRent: 1200, rooms: 1, bathrooms: 1, area: 40, status: 'occupied', tenantName: 'شركة القمة', tenantId: 'T003' },
    ]
  },
  {
    id: 'P002',
    name: 'مجمع السالمية بلازا',
    governorate: 'حولي',
    city: 'السالمية',
    block: '4',
    street: 'شارع سالم المبارك',
    buildingNumber: '88',
    civilId: '11223344',
    type: 'تجاري',
    buildYear: '2015',
    area: 2000,
    status: 'نشط',
    bankAccount: 'KFH - KW123123123',
    bookValue: 5000000,
    estimatedValue: 6500000,
    units: [
      { id: 'U5', unitNumber: 'Office-1', type: 'مكتب', rent: 800, contractRent: 800, rooms: 2, bathrooms: 1, area: 80, status: 'occupied', tenantName: 'مكتب المحامي فهد', tenantId: 'T004' },
      { id: 'U6', unitNumber: 'Office-2', type: 'مكتب', rent: 850, contractRent: 850, rooms: 2, bathrooms: 1, area: 85, status: 'vacant' },
    ]
  }
];

export const MOCK_TENANTS: Tenant[] = [
  {
    id: 'T001',
    type: TenantType.Individual,
    firstName: 'محمد',
    lastName: 'أحمد',
    email: 'mohamed@email.com',
    mobile: '99887766',
    language: 'Arabic',
    civilId: '290010101234',
    nationality: 'Egyptian',
    contractStart: '2023-01-01',
    contractEnd: '2024-01-01',
    predictedLeaving: '2024-02-01',
    hasLegalCase: false,
    sendWelcomeEmail: true,
    sendWelcomeSMS: true,
    rentPaymentDay: 1,
    paymentCycle: 'Monthly',
    assignedUnits: [{ propertyId: 'P001', unitId: 'U1', rent: 550 }]
  },
  {
    id: 'T002',
    type: TenantType.Individual,
    firstName: 'سارة',
    lastName: 'خالد',
    email: 'sara@email.com',
    mobile: '66554433',
    language: 'Arabic',
    civilId: '295050504321',
    nationality: 'Kuwaiti',
    contractStart: '2023-03-15',
    contractEnd: '2024-03-15',
    predictedLeaving: '',
    hasLegalCase: false,
    sendWelcomeEmail: true,
    sendWelcomeSMS: false,
    rentPaymentDay: 5,
    paymentCycle: 'Monthly',
    assignedUnits: [{ propertyId: 'P001', unitId: 'U2', rent: 550 }]
  },
  {
    id: 'T003',
    type: TenantType.Company,
    firstName: 'شركة',
    lastName: 'القمة',
    email: 'info@topcompany.com',
    mobile: '22446688',
    language: 'English',
    civilId: '12345678',
    nationality: 'Kuwaiti',
    contractStart: '2022-06-01',
    contractEnd: '2025-06-01',
    predictedLeaving: '',
    hasLegalCase: false,
    sendWelcomeEmail: true,
    sendWelcomeSMS: true,
    rentPaymentDay: 1,
    paymentCycle: 'Quarterly',
    assignedUnits: [{ propertyId: 'P001', unitId: 'U4', rent: 1200 }]
  }
];

export const MOCK_INVOICES: Invoice[] = [
  { id: 'INV-1001', date: '2023-10-01', dueDate: '2023-11-01', monthDue: 'أكتوبر 2023', tenantId: 'T001', tenantName: 'محمد أحمد', propertyId: 'P001', propertyName: 'برج الجوهرة', unitNumber: '101', amount: 550, contractRent: 550, isPaid: true, status: 'Paid' },
  { id: 'INV-1002', date: '2023-10-01', dueDate: '2023-11-01', monthDue: 'أكتوبر 2023', tenantId: 'T002', tenantName: 'سارة خالد', propertyId: 'P001', propertyName: 'برج الجوهرة', unitNumber: '102', amount: 550, contractRent: 550, isPaid: false, status: 'Pending' },
  { id: 'INV-1003', date: '2023-10-01', dueDate: '2023-11-01', monthDue: 'أكتوبر 2023', tenantId: 'T003', tenantName: 'شركة القمة', propertyId: 'P001', propertyName: 'برج الجوهرة', unitNumber: 'Store-1', amount: 3600, contractRent: 1200, isPaid: true, status: 'Paid' }, // Quarterly
  { id: 'INV-1004', date: '2023-10-01', dueDate: '2023-10-05', monthDue: 'أكتوبر 2023', tenantId: 'T004', tenantName: 'مكتب المحامي فهد', propertyId: 'P002', propertyName: 'مجمع السالمية', unitNumber: 'Office-1', amount: 800, contractRent: 800, isPaid: false, status: 'Late' },
];

export const MOCK_TRANSACTIONS: Transaction[] = [
  { id: 'EXP-001', categoryId: '1', amount: 450.500, date: '2023-10-05', description: 'فاتورة وزارة الكهرباء - برج الجوهرة', propertyId: 'P001', propertyName: 'برج الجوهرة', type: 'Expense' },
  { id: 'EXP-002', categoryId: '2', amount: 120.000, date: '2023-10-10', description: 'صيانة مصاعد دورية', propertyId: 'P001', propertyName: 'برج الجوهرة', type: 'Expense' },
  { id: 'EXP-003', categoryId: '3', amount: 300.000, date: '2023-10-01', description: 'راتب الحارس كومار', propertyId: 'P001', propertyName: 'برج الجوهرة', type: 'Expense' },
  { id: 'EXP-004', categoryId: '4', amount: 80.000, date: '2023-10-02', description: 'شركة التنظيف - شهر أكتوبر', propertyId: 'P002', propertyName: 'مجمع السالمية', type: 'Expense' },
];

export const MOCK_MAINTENANCE: MaintenanceRequest[] = [
  { id: 'REQ-001', propertyId: 'P001', propertyName: 'برج الجوهرة', unitId: 'U1', unitNumber: '101', description: 'تسريب مياه في الحمام الرئيسي', status: 'Pending', priority: 'High', dateReported: '2023-10-12' },
  { id: 'REQ-002', propertyId: 'P001', propertyName: 'برج الجوهرة', unitId: 'U3', unitNumber: '201', description: 'المكيف لا يعمل (وحدة شاغرة)', status: 'In Progress', priority: 'Medium', dateReported: '2023-10-10' },
  { id: 'REQ-003', propertyId: 'P002', propertyName: 'مجمع السالمية', description: 'إضاءة المدخل الرئيسي معطلة', status: 'Completed', priority: 'Low', dateReported: '2023-10-01' },
];